import React, { Component } from "react";
import { Menu } from "antd";
import { Link, Redirect } from "react-router-dom";
import SidebarFooter from "./Components/SidebarFooter";
import GenistaLogo from "../../assets/images/overhaul/images/GenistaLogo.svg";
import { isUser, getAppVersion } from "../../utils/helpers";
import { getAuthorizedRoutes } from "../../utils/authorizedRoutes";
import "./sidebar.css";

export default class Sidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedKeys: [],
      menuItemElements: [],
    };
    this.unlisten = null;
  }

  componentDidMount() {
    const routes = getAuthorizedRoutes();
    const path = window.location.pathname === "/" || window.location.pathname === "/login" ? routes[0].key : window.location.pathname.split("/")[1];
    const keys = [];
    keys.push(path);
    this.setState({
      selectedKeys: keys,
    });
    this.setState({
      menuItemElements: routes.map((route) => {
        const { key, sidebarIcon, sidebarLabel } = route;
        return {
          key,
          icon: typeof sidebarIcon === "string" ? <img src={sidebarIcon} alt="icon" className="sideBarMenuMargin" /> : sidebarIcon,
          label: <Link to={`/${key}`}>{sidebarLabel}</Link>,
        };
      }),
    });
    const { history } = this.props;
    this.unlisten = history.listen((location, action) => {
      // On refresh events, set the correct selected key based on the current window URL
      if (action === "POP") {
        const { selectedKeys } = this.state;
        const curPath = location.pathname;
        if (selectedKeys.length > 0 && !curPath.includes(selectedKeys[0])) {
          const foundItem = routes.find((item) => curPath.includes(item.key));
          if (foundItem) {
            this.setState({
              selectedKeys: [foundItem.key],
            });
          }
        }
      }
    });
  }

  componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  }

  redirectToMicro = () => {
    window.location = "/micro";
  }

  updateSelectedKeys(obj) {
    const key = obj.key;
    const selectedKeys = [];

    selectedKeys.push(key);

    this.setState({
      selectedKeys,
    });
  }

  render() {
    const {
      selectedKeys,
      menuItemElements,
    } = this.state;

    if (!isUser()) {
      return <Redirect to="/login" />;
    }
    return (
      <div className="sideBarMenuStyle">
        <div className="App__Version">{getAppVersion()}</div>
        <div className="project-logo">
          <img
            src={GenistaLogo}
            alt="genista"
            // onClick={() => this.redirectToMicro()}
          />
        </div>
        <Menu
          theme="dark"
          mode="inline"
          className="sidebarMenuItems"
          selectedKeys={selectedKeys}
          onSelect={(obj) => this.updateSelectedKeys(obj)}
          items={menuItemElements}
        />
        <SidebarFooter />
      </div>
    );
  }
}
